import React, { useEffect, useState } from 'react';
import { Stock } from '../model/stock';
import { StockService } from '../../services/stock.service';
import { AuthService } from '../../services/auth.service';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Box,
} from '@mui/material';

const LowStockList: React.FC = () => {
  const [stocks, setStocks] = useState<Stock[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const institutionId = AuthService.getSelectedInstitution();
    if (!institutionId) return;

    setLoading(true);
    StockService.getLowStock(institutionId)
      .then(data => setStocks(data))
      .catch(error => console.error('Error fetching low stock items:', error))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Low Stock Alerts
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ mb: 3 }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell>#</TableCell>
                <TableCell>Item Code</TableCell>
                <TableCell>Item Name</TableCell>
                <TableCell>Store</TableCell>
                <TableCell>Available Qty</TableCell>
                <TableCell>Reorder Level</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {stocks.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No low stock items found
                  </TableCell>
                </TableRow>
              ) : (
                stocks.map((stock, index) => (
                  <TableRow key={stock.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{stock.item?.itemCode ?? '-'}</TableCell>
                    <TableCell>{stock.item?.itemName ?? '-'}</TableCell>
                    <TableCell>{stock.store?.storeName ?? '-'}</TableCell>
                    <TableCell>{stock.availableQty}</TableCell>
                    <TableCell>{stock.reorderLevel ?? '-'}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default LowStockList;
